import type { InstagramConnectedAccount, InstagramConnectionState } from "@multi-chat/shared";

export type InstagramAccountTypeLabelKey =
  | "instagram.accountType.business"
  | "instagram.accountType.creator"
  | null;

export function instagramAccountTypeLabelKey(
  accountType: InstagramConnectedAccount["accountType"] | string | null | undefined,
): InstagramAccountTypeLabelKey {
  switch (accountType) {
    case "BUSINESS":
      return "instagram.accountType.business";
    case "MEDIA_CREATOR":
      return "instagram.accountType.creator";
    default:
      return null;
  }
}

export function instagramStateBadgeVariant(
  state: InstagramConnectionState,
): "default" | "success" | "warning" | "error" {
  switch (state) {
    case "CONNECTED":
      return "success";
    case "ERROR":
      return "error";
    case "DISCONNECTED":
    case "NOT_CONNECTED":
      return "default";
    default: {
      const _exhaustive: never = state;
      return _exhaustive;
    }
  }
}

export function instagramStateLabelKey(state: InstagramConnectionState): string {
  switch (state) {
    case "NOT_CONNECTED":
    case "DISCONNECTED":
      return "instagram.notConnected.title";
    case "CONNECTED":
      return "instagram.connected.title";
    case "ERROR":
      return "instagram.error.title";
    default: {
      const _exhaustive: never = state;
      return _exhaustive;
    }
  }
}

/** Username display with leading @; empty/whitespace → null. */
export function formatInstagramUsername(username: string | null | undefined): string | null {
  if (!username) return null;
  const trimmed = username.trim();
  if (!trimmed) return null;
  return trimmed.startsWith("@") ? trimmed : `@${trimmed}`;
}
